import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import GuestLayout from 'global/GuestLayout';
import styled, { css } from 'styled-components';
import GuestCompanyBackground from './GuestCompanyBackground';
import Navbar from './Navbar';

interface FinancialWrapperProps {
  fullscreen?: boolean;
}

// eslint-disable-next-line space-infix-ops
const FinancialWrapper = styled.div<FinancialWrapperProps>`
  margin: auto;
  padding-bottom: 20px;
  width: 100%;

  ${({ fullscreen }) =>
    fullscreen &&
    css`
      background-color: ${color.light};
      height: calc(100% - 60px);
      left: 0px;
      margin: auto;
      overflow-y: scroll;
      padding: 20px;
      position: fixed;
      top: 60px;
      z-index: 10;

      @media ${device.tablet} {
        height: calc(100% - 100px);
        top: 100px;
        width: 100%;
      }

      @media ${device.laptop} {
        width: 100%;
      }
    `}
`;

const EmptyWrapper = styled.div`
  align-items: center;
  background: ${color.light};
  border: 1px solid ${color.gainsboro};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px auto auto auto;
  padding: 25px 0;
  height: 320px;
`;

const RegisterButton = styled(Button).attrs({ type: 'primary', as: 'a' })`
  align-items: center;
  display: flex;
  height: 40px;
  justify-content: center;
  width: 100%;
`;

const Banner = styled.div.attrs({ type: 'primary', as: 'a' })`
  display: none;

  @media ${device.tablet} {
    display: flex;
  }
`;

const GuestDocumentLayout = styled(GuestLayout)`
  background-color: ${color.light};
  padding: 0;

  @media ${device.tablet} {
    padding: 0;
  }

  @media ${device.laptop} {
    background-color: ${color.whiteSmoke};
    padding: 0;
  }
`;

const CustomGuestCompanyBackground = styled(GuestCompanyBackground)`
  margin: 0 20px 20px;

  @media ${device.tablet} {
    margin: 0 0 20px 0;
  }
`;

const GuestNavbar = styled(Navbar)`
  ${({ isCompanyStock }) =>
    isCompanyStock &&
    css`
      margin: 0px 0 20px 0;
    `}
`;

const GuestStreamWrapper = styled(Flex)`
  ${
    // @ts-expect-error
    ({ isCompanyStock }) =>
      isCompanyStock &&
      css`
        padding: 0 20px;

        @media ${device.tablet} {
          padding: 0;
        }
      `
  }
`;

export const GuestChartWrapper = styled.div`
  background-color: #fff;
  padding: 12px 0;
  margin-bottom: 20px;

  @media ${device.tablet} {
    border: 1px solid ${color.gainsboro};
    border-top: none;
  }
`;

export {
  EmptyWrapper,
  FinancialWrapper,
  RegisterButton,
  Banner,
  GuestDocumentLayout,
  CustomGuestCompanyBackground,
  GuestNavbar,
  GuestStreamWrapper,
};
